import React from 'react'

import { useAnalysisType } from 'redux/hooks/AnalysisTypes'
import { useTranslation } from 'language/translator'
import { useParams } from 'utils/hooks'

import {
  BreadcrumbsProps,
  TBreadcrumbItem
} from 'components_new/molecules/Breadcrumbs'

import AnalysisNavigation from 'components_new/organisms/analysis_types/AnalysisTypeNavigation'

import PageLayout, {
  PageLayoutProps
} from 'components_new/templates/PageLayout'

interface AnalysisTemplateProps
  extends Omit<PageLayoutProps, 'rightSidebar' | 'topbar'> {
  topbar?: Pick<NonNullable<PageLayoutProps['topbar']>, 'actions'>
  rightSidebar?: Pick<
    NonNullable<PageLayoutProps['rightSidebar']>,
    'collapsed' | 'content' | 'setCollapsed' | 'size'
  >
  subpage?: TBreadcrumbItem
}

const AnalysisTypeTemplate = (props: AnalysisTemplateProps) => {
  const { children, rightSidebar, subpage, topbar, ...rest } = props

  const { id } = useParams()
  const { analysisType } = useAnalysisType(id)
  const { t } = useTranslation()

  const breadcrumbs: BreadcrumbsProps['items'] = [
    {
      href: '/analysis-types',
      icon: { name: 'AnalysisTypes' },
      title: t('analysis_types', 'analysis_types')
    }
  ]

  if (analysisType) {
    breadcrumbs.push({
      href: `/analysis-types/${analysisType.id}`,
      title: analysisType.name
    })
  }

  if (subpage) {
    breadcrumbs.push(subpage)
  }

  return (
    <PageLayout
      content={{
        size: 'large'
      }}
      rightSidebar={{
        collapsed: rightSidebar?.collapsed,
        content: rightSidebar?.content,
        navigation: <AnalysisNavigation />,
        size: rightSidebar?.size ?? 'small',
        setCollapsed: rightSidebar?.setCollapsed
      }}
      topbar={{
        actions: topbar?.actions,
        breadcrumbs: breadcrumbs,
        mobile: {
          goBack: true
        }
      }}
      {...rest}
    >
      {children}
    </PageLayout>
  )
}

export default AnalysisTypeTemplate
